import { createStore } from "hooksy";

interface State {
  fetchList: boolean;
}

const defaultValue: State = { fetchList: false };

export const [useRoleStore] = createStore(defaultValue);
